import { getValueFromToken } from './getValueFromToken';

export const isSuperAdminCustomer = () => {
  return getValueFromToken('isSuperAdmin');
};

export const isAdminEditing = () => {
  return window.location.pathname.includes('admin/');
};
